export default __webpack_public_path__ + "static/media/Active_Shipment.6e2a02ba.svg";